<template>
    <header
            class="relative flex items-start px-4 py-0 space-x-2 text-white sm:px-8 md:px-16 lg:px-20 xl:px-28 t3m-Section-header t3m-Section-header--flx">
        <h3 v-if="!linkedSlides.length"
            class="mb-0 font-normal h4">
            {{ title || "" }}
        </h3>
        <dropdown v-if="linkedSlides.length">
            <template v-slot:dropdown-title>
                {{ title || "" }}
            </template>
            <template v-slot:dropdown-menu>
                <a v-for="(s, indx) in linkedSlides"
                   :key="indx"
                   :href="s.link"
                   class="px-2 py-1 rounded hover:bg-gray-100 text-t3m-body"
                   :aria-label="s.title"
                   v-html="s.title">
                </a>
            </template>
        </dropdown>
    </header>
</template>

<script>
import Dropdown from "@/components/Dropdown";

export default {
    name: "VSectionHeader",
    components: {
        Dropdown,
    },
    props: {
        title: String,
        slides: Object,
    },
    computed: {
        linkedSlides() {
            return this.slides.filter((s) => {
                return s.link.length;
            });
        },
    },
};
</script>
